export default "__VITE_ASSET__8gb_llZ3__"